// extracted by mini-css-extract-plugin
export var formContainer = "_cd-0";
export var message = "_cd-1";